<nps-loader #vcNPS></nps-loader>

<mat-sidenav-container class="shell">
  <mat-sidenav [mode]="drawerMode" class="aside" #drawer>
    <nav
      #nav
      class="nav"
      [ngClass]="{ '--overflowing': navVerticalOverflow == true }"
    >
      <!-- todo @if: backend sends host-submark-logo -->
      <div class="nav__section --top --has-submark-logo">
        @if (currentTheme == 'theme-light') {
          <img
            [src]="baseUrl + '/general/logo/light'"
            class="host-logo"
            alt=""
          />
        } @else if (currentTheme == 'theme-dark') {
          <img
            [src]="baseUrl + '/general/logo/dark'"
            class="host-logo"
            alt=""
          />
        }
        <div class="d-flex flex-wrap gap-2">
          @if (currentTheme == 'theme-light') {
            <img
              [src]="baseUrl + '/general/sub-logo/light'"
              class="host-logo-submark"
              alt=""
            />
          } @else if (currentTheme == 'theme-dark') {
            <img
              [src]="baseUrl + '/general/sub-logo/dark'"
              class="host-logo-submark"
              alt=""
            />
          }

          <button
            class="drawer-toggle-button"
            mat-icon-button
            (click)="toggleDrawer()"
          >
            <mat-icon>{{ drawer.opened ? 'menu_open' : 'menu' }}</mat-icon>
          </button>
        </div>
      </div>

      <!-- todo @if: backend does NOT send host-submark-logo -->
      <!-- <div class="nav__section --top">
        @if (currentTheme == 'theme-light') {
          <img
            width="150px"
            [src]="baseUrl + '/general/logo/light'"
            class="host-logo"
            alt=""
          />
        } @else if (currentTheme == 'theme-dark') {
          <img
            width="150px"
            [src]="baseUrl + '/general/logo/dark'"
            class="host-logo"
            alt=""
          />
        }
        <button mat-icon-button (click)="toggleDrawer()">
          <mat-icon>{{ drawer.opened ? 'menu_open' : 'menu' }}</mat-icon>
        </button>
      </div> -->

      @if (shellService.navigationSections) {
        <ul class="nav__list">
          @for (
            section of shellService.navigationSections;
            track section;
            let listIndex = $index
          ) {
            <li
              class="nav__list-item"
              [ngClass]="{ '--has-sublist': listIndex == 1 }"
            >
              @if (listIndex != 1) {
                <button
                  class="nav__button"
                  matRipple
                  [matTooltip]="section.title"
                  [matTooltipDisabled]="drawer.opened"
                  matTooltipShowDelay="800"
                  matTooltipPosition="right"
                  (click)="routeTo(section.url_tree)"
                  [extendedRouterLink]="section.url_tree"
                  extendedRouterLinkActive="selected"
                >
                  <span class="nav__label text-truncate">
                    {{ section.title | translate }}
                  </span>
                  <mat-icon class="--selected-fill">{{
                    section.icon
                  }}</mat-icon>
                </button>
              }

              @if (listIndex == 1) {
                <button
                  class="nav__button"
                  matRipple
                  [matTooltip]="section.title"
                  [matTooltipDisabled]="drawer.opened"
                  matTooltipShowDelay="800"
                  matTooltipPosition="right"
                  [routerLink]="section.url_tree"
                  [extendedRouterLink]="section.url_tree"
                  extendedRouterLinkActive="selected"
                >
                  <span class="nav__label text-truncate">
                    {{ section.title | translate }}
                  </span>
                  <mat-icon class="--selected-fill">{{
                    section.icon
                  }}</mat-icon>
                </button>
                <ul class="nav__list --sublist">
                  @for (
                    subSection of section.sub_navigations;
                    track subSection;
                    let subListIndex = $index
                  ) {
                    @if (listIndex == 1) {
                      <li class="nav__list-item">
                        <button
                          class="nav__button"
                          matRipple
                          [matTooltip]="subSection.title"
                          [matTooltipDisabled]="drawer.opened"
                          matTooltipShowDelay="800"
                          matTooltipPosition="right"
                          [routerLink]="subSection.url_tree"
                          [extendedRouterLink]="subSection.url_tree"
                          extendedRouterLinkActive="selected"
                        >
                          <span class="nav__label text-truncate">
                            {{ subSection.title | translate }}
                          </span>
                          <mat-icon class="--selected-fill">{{
                            subSection.icon
                          }}</mat-icon>
                        </button>
                      </li>
                      <!-- @for (
                        subSection2 of subSection.sub_navigations;
                        track subSection2
                      ) {
                        <li class="nav__list-item">
                          <button
                            class="nav__button"
                            matRipple
                            [routerLink]="subSection2.url_tree"
                            [extendedRouterLink]="subSection2.url_tree"
                            extendedRouterLinkActive="selected"
                          >
                            <span class="nav__label text-truncate">
                              {{ subSection2.title | translate }}
                            </span>
                            <mat-icon>{{ subSection2.icon }}</mat-icon>
                          </button>
                        </li>
                      } -->
                    }
                  }
                </ul>
              }
            </li>
          }
          <li class="nav__list-item">
            <button
              class="nav__button"
              matRipple
              [matTooltip]="'settings' | translate"
              [matTooltipDisabled]="drawer.opened"
              matTooltipShowDelay="800"
              matTooltipPosition="right"
              [matMenuTriggerFor]="settingsMenu"
            >
              <span class="nav__label text-truncate">
                {{ 'settings' | translate }}
              </span>
              <mat-icon class="--selected-fill">settings</mat-icon>
            </button>
            <mat-menu #settingsMenu="matMenu" xPosition="after">
              <section class="mat-menu-section">
                <p class="mat-menu-section__heading">
                  {{ 'color_scheme' | translate }}
                </p>
                <div class="color-scheme-section mx-2">
                  <button
                    mat-icon-button
                    class="m3-icon-toggle-button"
                    [matTooltip]="'Color_scheme_light' | translate"
                    matTooltipShowDelay="800"
                    [ngClass]="{ '--selected': currentTheme === 'theme-light' }"
                    (click)="themingService.setSelectedTheme('theme-light')"
                  >
                    <mat-icon class="--selected-fill">light_mode</mat-icon>
                  </button>
                  <!-- TODO: implement in theming component and add auto mode -->
                  <!-- <button
                    mat-icon-button
                    class="m3-icon-toggle-button"
                    [matTooltip]="'Color_scheme_auto' | translate"
                    matTooltipShowDelay="800"
                    disabled
                  >
                    <mat-icon>routine</mat-icon>
                  </button> -->
                  <button
                    mat-icon-button
                    class="m3-icon-toggle-button"
                    [matTooltip]="'Color_scheme_dark' | translate"
                    matTooltipShowDelay="800"
                    [ngClass]="{ '--selected': currentTheme === 'theme-dark' }"
                    (click)="themingService.setSelectedTheme('theme-dark')"
                  >
                    <mat-icon class="--selected-fill">dark_mode</mat-icon>
                  </button>
                </div>
              </section>
            </mat-menu>
          </li>
        </ul>
      }

      <div class="nav__section --bottom">
        <ul class="nav__list">
          <li class="nav__list-item">
            <button
              (click)="logout()"
              class="nav__button"
              [matTooltip]="'Logout' | translate"
              matTooltipShowDelay="800"
              matTooltipPosition="right"
              [matTooltipDisabled]="drawer.opened"
            >
              <div class="nav__label">
                <div class="nav__section-heading text-truncate">
                  {{ 'Currently_logged_in_as' | translate }}
                </div>
                <div class="text-truncate">
                  @if (customer?.first_name && customer?.last_name) {
                    {{ customer?.first_name }} {{ customer?.last_name }}
                  } @else if (customer?.email) {
                    {{ customer?.email }}
                  }
                </div>
              </div>
              <mat-icon>logout</mat-icon>
            </button>
          </li>
        </ul>
        <!-- <div>
          <div class="nav__section-heading">{{ "Currently_logged_in_as" | translate }}</div>
          <div>Vorname Nachname</div>
        </div>
        <button mat-icon-button color="secondary">
          <mat-icon>logout</mat-icon>
        </button> -->
      </div>

      <!-- <div class="nav__section --bottom">
        <ul class="nav__list">
          <li class="nav__list-item">
            <button class="nav__button" matRipple [matMenuTriggerFor]="menu">
              <span class="nav__label text-truncate">
                {{ 'settings' | translate }}
              </span>
              <mat-icon>settings</mat-icon>
            </button>
            <mat-menu #menu="matMenu" xPosition="after">
              <section class="mat-menu-section">
                <p class="mat-menu-section__heading">
                  {{ 'color_scheme' | translate }}
                </p>
                <div class="color-scheme-section mx-2">
                  <button
                    mat-icon-button
                    class="m3-icon-toggle-button"
                    [matTooltip]="'Color_scheme_light' | translate"
                    matTooltipShowDelay="800"
                    [ngClass]="{ '--selected': currentTheme === 'theme-light' }"
                    (click)="themingService.setSelectedTheme('theme-light')"
                  >
                    <mat-icon>light_mode</mat-icon>
                  </button>
                   todo @marius: implement auto mode
                  <button
                    mat-icon-button
                    class="m3-icon-toggle-button"
                    [matTooltip]="'Color_scheme_auto' | translate"
                    matTooltipShowDelay="800"
                    disabled
                  >
                    <mat-icon>routine</mat-icon>
                  </button>
                  <button
                    mat-icon-button
                    class="m3-icon-toggle-button"
                    [matTooltip]="'Color_scheme_dark' | translate"
                    matTooltipShowDelay="800"
                    [ngClass]="{ '--selected': currentTheme === 'theme-dark' }"
                    (click)="themingService.setSelectedTheme('theme-dark')"
                  >
                    <mat-icon>dark_mode</mat-icon>
                  </button>
                </div>
              </section>
            </mat-menu>
          </li>
        </ul>
      </div> -->
    </nav>
  </mat-sidenav>
  <mat-sidenav-content
    class="main"
    cdkScrollable
    id="mainScrollElement"
    [ngClass]="{
      'drawer--mode-side': drawer?.mode === 'side',
      'drawer--open': drawer?.opened,
    }"
  >
    <header class="header">
      <button
        mat-icon-button
        (click)="toggleDrawer()"
        class="drawer-toggle-button"
      >
        <mat-icon>menu</mat-icon>
      </button>
    </header>
    <div class="content-container fade-in">
      <router-outlet></router-outlet>
      @if (showScrollToTopButton) {
        <button
          mat-fab
          color="secondary"
          class="scroll-to-top-btn"
          (click)="scrollToTop()"
        >
          <mat-icon>vertical_align_top</mat-icon>
        </button>
      }
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
